/* global newrelic */
import IS_BROWSER from 'shared/app/shell/utils/is-browser';

export const customNewRelicReport = (name = '', attributes = {}) => {
  if (!IS_BROWSER || !window.newrelic) {
    return;
  }
  return newrelic?.addPageAction(name, attributes);
};
